import styled from 'styled-components';

export const DescriptionContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
`;

export const styleText = {
    color: '#5B5B5B',
    marginBottom: '20px',
};
